import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ObjectHelper {
    public clone<T extends object>(source: T): T {
        const result = Object.create(source);
        Object.assign(result, source);
        return result as T;
    }
}
